<template>
  <v-dialog v-model="mrtgopen" max-width="50rem" persistent>
    <v-card  class="elevation-0 rounded-0">
      <v-toolbar color="#f7f7f7" class="elevation-0 rounded-0"  dense>
        MRTG Traffic

        <v-spacer></v-spacer>

        <v-btn small class="elevation-0 rounded-0" icon  @click="removeMRTG()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider ></v-divider>
      <v-toolbar v-if="mrtgSailink" class="elevation-0 rounded-0"  dense  >
        <v-toolbar-subtitle 
          >{{ mrtgSailink.vessel_pt }} | {{ status_mrtg }}</v-toolbar-subtitle
        >

        <v-spacer></v-spacer>
      </v-toolbar>
      <v-divider v-if="mrtgSailink"></v-divider>
      <v-container style="margin-top:0" v-if="!mrtgSailink" fill-height fluid>
        <v-row align="center" justify="center">
          <v-col
            ><img
              alt="Navplus logo"
              width="70px"
              :src="loadernavplus"
              class="justify-center"
          /></v-col>
        </v-row>
      </v-container>

      <div v-if="mrtgSailink" class="ma-2">
        <v-card :key="i" class="mx-auto content_modal elevation-0 rounded-0" max-width="45rem"  style="border: solid 1px #e0e0e0">
          <v-toolbar color="#f7f7f7" dense class="elevation-0 rounded-0"
            ><v-text>Hourly (1 Minute Average)</v-text></v-toolbar
          >
          <v-img
            v-if="mrtgSailink"
            class="imgmodal"
            v-bind:src="mrtgSailink.base64.data5"
          ></v-img>
        </v-card>

        <v-card :key="i" class="mx-auto content_modal elevation-0 rounded-0" max-width="45rem"  style="border: solid 1px #e0e0e0">
          <v-toolbar color="#f7f7f7"  dense class="elevation-0 rounded-0"
            ><v-text>Daily (5 Minute Average)</v-text></v-toolbar
          >
          <v-img
            v-if="mrtgSailink"
            class="imgmodal"
            v-bind:src="mrtgSailink.base64.data1"
          ></v-img>
        </v-card>

        <v-card :key="i" class="mx-auto content_modal elevation-0 rounded-0" max-width="45rem"  style="border: solid 1px #e0e0e0">
          <v-toolbar color="#f7f7f7"  dense class="elevation-0 rounded-0"
            ><v-text>Weekly (30 Minute Average)</v-text></v-toolbar
          >
          <v-img
            v-if="mrtgSailink"
            class="imgmodal"
            v-bind:src="mrtgSailink.base64.data2"
          ></v-img>
        </v-card>

        <v-card :key="i" class="mx-auto content_modal elevation-0 rounded-0" max-width="45rem"  style="border: solid 1px #e0e0e0">
          <v-toolbar color="#f7f7f7"  dense class="elevation-0 rounded-0"
            ><v-text>Monthly (2 Hour Average)</v-text></v-toolbar
          >
          <v-img
            v-if="mrtgSailink"
            class="imgmodal"
            v-bind:src="mrtgSailink.base64.data3"
          ></v-img>
        </v-card>

        <v-card :key="i" class="mx-auto content_modal elevation-0 rounded-0" max-width="45rem"  style="border: solid 1px #e0e0e0">
          <v-toolbar color="#f7f7f7"  dense class="elevation-0 rounded-0"
            ><v-text>Yearly (1 Day Average)</v-text></v-toolbar
          >
          <v-img
            v-if="mrtgSailink"
            class="imgmodal"
            v-bind:src="mrtgSailink.base64.data4"
          ></v-img>
        </v-card>
      </div>

      <v-card-actions class="justify-end"> </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
    data(){
        return{
            loadernavplus: require("@/assets/img/load100new.gif"),
        }
    },
  methods: {
    ...mapActions([
      "removeSearch",
      "fetchMySailink",
      "updateVesselName",
      "fetchMRTG",
      "removeMRTG",
      "showonMap",
      "ipAdr",
      "lnStatus",
      "showondate",
      "addShowClick",
    ]),
  },

  computed: {
    ...mapGetters([
      "sailinkData",
      "mrtgSailink",
      "showmaptable",
      "searchVessel",
      "searchVesselID",
      "showmapclick",
      "status_mrtg",
      "mrtgopen",
    ]),
  },
};
</script>

<style lang="scss" scoped>

.v-dialog {
  box-shadow: none;
  border-radius:0;
}
</style>
